// extracted by mini-css-extract-plugin
module.exports = {"container":"_2eDlDnCu-KPlQeSVlOC4FT","groupsList":"_12o_w6AhsbwaQkNMcnxuwy"};